<div id="safety-macro-group-form"></div>